export default __webpack_public_path__ + "static/media/insta1.1d2ab784.png";